'use client'

import { PropsWithChildren, ReactNode } from 'react'
import { features } from '@/lib/config'

export default function Layout({
  children,
  subCategoriesSlider,
}: PropsWithChildren<{
  subCategoriesSlider: ReactNode
}>) {
  return (
    <div className="category-layout tw-h-full tw-w-full">
      {!features.compactCategoryNavigation && subCategoriesSlider}

      <div className="category-layout-content">{children}</div>
    </div>
  )
}
